import type {
  CreatePayload,
  UpdatePayload,
} from 'services/apiV3/orders/orders';
import { orders } from 'services/apiV3/orders/orders';

const create = (payload = {}) => {
  return orders.create(payload as CreatePayload);
};

const update = ({
  id,
  ...payload
}: {
  id: string;
  token: string;
  metadata: Record<string, string>;
}) => {
  return orders.update({ orderId: id, ...payload } as UpdatePayload);
};

const addToUser = ({ orderId, token }) => {
  return orders.addOrderToUser({ orderId, token });
};

const fetch = ({ orderId, token }) => {
  return orders.fetch({ orderId, token });
};

const addCoupon = ({ id, token, couponCode }) => {
  return orders.addCoupon({ id, token, couponCode });
};

export { addCoupon, addToUser, create, fetch, update };
